//import Home from './pages/home_page/HeroPage';
import Header from '../home_page/Header'
import Hero from '../home_page/Hero'


const Home = () => {
  return (
    <>
      {/* <NavHome/> */}
      <Header />
      <Hero/>
    </>
  );
};

export default Home;
